import Alerts from './alert.component'

export default Alerts